import moment from 'moment-timezone'
import { Link } from 'react-router'
import { CompletedSpecTestRun, RunManifest, RunStatus } from '@signifyd/cypress'
import RunStatusTag from 'core/components/RunStatusTag/RunStatusTag'
import { ColumnType } from 'antd/lib/table'

type SpecRecord = Omit<CompletedSpecTestRun, 'tests' | 'runId'>

export const getColumns = (
  projectName: string,
  runId: string,
  navPrefix: string
): Array<ColumnType<SpecRecord>> => [
  {
    title: 'Spec File Name',
    dataIndex: 'specFileName',
    key: 'specFileName',
    width: 300,
    render: (specFileName: string) => (
      <Link
        to={`/playwright/spec-file/${projectName}/${runId}/${specFileName}${navPrefix}`}
      >
        {specFileName}
      </Link>
    ),
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    render: (status: RunStatus) => <RunStatusTag runStatus={status} />,
  },
  {
    title: 'Total Duration',
    dataIndex: 'totalDuration',
    key: 'totalDuration',
    render: (duration: number) =>
      `${moment
        .duration(duration, 'milliseconds')
        .asSeconds()
        .toFixed(2)} seconds`,
  },
]

export const getTestCasesColumns = (
  projectName: string,
  runId: string,
  navPrefix: string
): Array<ColumnType<SpecRecord>> => {
  const defaultColumns = getColumns(projectName, runId, navPrefix)

  return [
    ...defaultColumns,
    {
      title: 'Total test cases',
      dataIndex: 'totalTests',
      key: 'totalTests',
    },
    { title: 'Total passed', dataIndex: 'passed', key: 'passed' },
    { title: 'Total failed', dataIndex: 'failed', key: 'failed' },
    { title: 'Total flaky', dataIndex: 'flaky', key: 'flaky' },
    { title: 'Total skipped', dataIndex: 'skipped', key: 'skipped' },
    {
      title: 'Total interrupted',
      dataIndex: 'interrupted',
      key: 'interrupted',
    },
  ]
}

export const getTableData = (testData: RunManifest): RunManifest => {
  const failed = testData.specs.filter(
    (specFile) => specFile.status === 'failed'
  ).length
  const passed = testData.specs.filter(
    (specFile) => specFile.status === 'passed'
  ).length
  const flaky = testData.specs.filter(
    (specFile) => specFile.status === 'flaky'
  ).length
  const skipped = testData.specs.filter(
    (specFile) => specFile.status === 'skipped'
  ).length
  const interrupted = testData.specs.filter(
    (specFile) => specFile.status === 'interrupted'
  ).length

  return {
    ...testData,
    totalTests: testData.specs.length,
    failed,
    passed,
    flaky,
    skipped,
    interrupted,
  }
}
